import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { EmailFeedService } from 'src/app/services/integrations/email/email-feed.service';
import ClientProcessor from './email-feeds/client-processor';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import FileSaver from 'file-saver';
import * as de from 'src/assets/calendar-assets/core/locales/de';
import { NoteService } from 'src/app/services/notes/note.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { noWhitespaceValidator } from 'src/app/utils/no-whitespace.validator';
import { takeUntil, map, finalize } from 'rxjs/operators';
import { Subject, forkJoin } from 'rxjs';
import * as $ from 'jquery';
import { GeneralService } from 'src/app/services/general.service';
import { AllFeedsComponent } from './all-feeds/all-feeds.component';
import { LogActivityService } from 'src/app/services/settings-services/log-activity.service';
import { ActivityCommentService } from 'src/app/services/settings-services/activity-comment.service';
import { SignupLoginService } from 'src/app/services/signupLogin.service';
import { GeneralTaskService } from 'src/app/services/task/general-task.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

/**
 * A user that can be tagged in a comment, mapped from the organisation user list
 */
export interface MentionUser {
  id: string;
  name: string;
  email: string;
}

/**
 * A user that has been tagged in the draft comment
 */
export interface MentionedUser {
  id: string;
  name: string;
}

/**
 * Matches an "@" token that is still being typed at the caret position
 */
const MENTION_TOKEN_REGEX = /(^|\s)@([\w.\- ]{0,40})$/;
const MAX_MENTION_SUGGESTIONS = 8;
const MENTION_PICKER_BLUR_DELAY = 150;
const DEFAULT_FOLLOW_UP_TIME = '09:00';

@Component({
  selector: 'app-feeds',
  templateUrl: './feeds.component.html',
  styleUrls: ['./feeds.component.css']
})
export class FeedsComponent implements OnInit, OnDestroy {
  @ViewChild(AllFeedsComponent) feeds: AllFeedsComponent
  @ViewChild('commentTextarea') commentTextarea: ElementRef;
  private unsubscribe = new Subject<any>();
  clientsProcessor = ClientProcessor;
  selectedMail: any;
  mailAttachments: Array<any>;
  note: any = {};
  selectedActivityID: string = '';
  editedOrgAct: any = {};
  activityType: any = [];
  showLoading: boolean = false;
  showNoteLoading: boolean = false;
  showEditLoading: boolean = false;
  pageContext
  user;
  orgID;
  comments: Array<any> = [];
  showCommentsLoading: boolean = false;
  isPostingComment: boolean = false;
  commentForm = new FormGroup({
    content: new FormControl('', [Validators.required, noWhitespaceValidator])
  });
  showFollowUpForm: boolean = false;
  isCreatingTask: boolean = false;
  restricDateTYP = new Date();
  /** Cached organisation users available for tagging (loaded on first @) */
  organisationUsers: MentionUser[] = [];
  private organisationUsersRequested: boolean = false;
  /** Current @ suggestions rendered in the picker */
  mentionSuggestions: MentionUser[] = [];
  mentionQuery: string = null;
  showMentionPicker: boolean = false;
  mentionActiveIndex: number = 0;
  /** Users tagged in the draft comment */
  mentionedUsers: MentionedUser[] = [];
  private mentionStart: number = -1;
  private mentionEnd: number = -1;
  supervisorAttachedUsers: Array<any> = [];
  private supervisorUsersLoaded: boolean = false;
  private supervisorUsersLoading: boolean = false;
  followUpForm = new FormGroup({
    name: new FormControl('', [Validators.required, noWhitespaceValidator]),
    description: new FormControl('', [Validators.required, noWhitespaceValidator]),
    assigneeID: new FormControl('', Validators.required),
    dueDate: new FormControl('', Validators.required),
    dueTime: new FormControl('', Validators.required)
  });
  editNoteForm = new FormGroup({
    content: new FormControl('', [Validators.required, noWhitespaceValidator]),
    noteID: new FormControl(''),
    assigneeID: new FormControl(''),
    clientID: new FormControl(''),
    clientName: new FormControl(''),
    creatorName: new FormControl(''),
    dealCode: new FormControl(''),
    dealName: new FormControl(''),
    teamID: new FormControl(''),
    otherName: new FormControl(''),
    otherID: new FormControl(''),
    createdDate: new FormControl(''),
  })

  editActivityForm = this.formBuilder.group({
    content: new FormControl('', [Validators.required, noWhitespaceValidator]),
    type: new FormControl('', Validators.required),
    id: new FormControl(''),
    assigneeID: new FormControl(''),
    clientID: new FormControl(''),
    clientName: new FormControl(''),
    createdDate: new FormControl(''),
    creatorName: new FormControl(''),
    dateLogged: new FormControl(''),
    dealCode: new FormControl(''),
    dealName: new FormControl(''),
    duration: new FormControl(''),
    otherName: new FormControl(''),
    otherID: new FormControl(''),
    teamID: new FormControl(''),
  });

  constructor(
    private formBuilder: FormBuilder,
    private emailFeedService: EmailFeedService,
    private emailService: EmailService,
    private noteSrv: NoteService,
    private logSrv: LogActivityService,
    private generalSrv: GeneralService,
    private activityCommentSrv: ActivityCommentService,
    private signupSrv: SignupLoginService,
    private generalTaskSrv: GeneralTaskService,
    store: Store<AppState>
  ) {
    store.select('userInfo').subscribe((info) => {
      if (!info) return;
      this.orgID = info.organization ? info.organization.id : null;
      this.user = info.user;
      this.seedCurrentUserForFollowUp();
    });
  }

  ngOnInit() {

    this.fetchLogActivityTypes();

    this.emailService.email_context.subscribe((context: any) => {
      if (!this.generalSrv.checkIfObjectIsEmpty(context)) {
        this.pageContext = context.name;
        this.openPendingActivity();
      }
    });

    /**
     * Opens an activity requested from a notification. The request is one-shot,
     * so a reload of the page cannot reopen the modal again.
     */
    this.logSrv.openActivity$.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.openPendingActivity();
    });

    this.emailService.emailToActOn.subscribe((mail: any) => {
      if (Object.keys(mail).length) {
        let dealName = '', dealCode = '';
        if (mail.thread && mail.thread.deal) {
          dealName = mail.thread.deal.name || '';
          dealCode = mail.thread.deal.id || '';
        }
        this.selectedMail = { ...mail, dealCode, dealName };
        if (this.selectedMail.service === 'mailgun') {
          const receiver = this.selectedMail.headers.To;
          let extractMail;
          if (receiver.indexOf('<') > -1) {
            extractMail = this.selectedMail.headers.To.split('<')[1];
            extractMail = extractMail.substr(0, extractMail.length - 1);
          } else {
            extractMail = receiver;
          }

          this.selectedMail = {
            ...this.selectedMail,
            content: this.selectedMail.body,
            recipient: extractMail
          }
        }

      }
    })

    this.emailFeedService.mailAttachments.subscribe((attachments: any[]) => {
      if (attachments.length) {
        let attachmentMap = attachments.reduce((atts, attachment) => {
          return {
            ...atts,
            [attachment.name]: attachment,
          };
        }, {});

        this.mailAttachments = Object.keys(attachmentMap).map(key => ({ ...attachmentMap[key] }));
      }
    })

    this.noteSrv.noteItem.subscribe(data => {
      if (!data) return
      if (data) {
        this.onViewSingleNote(data);
      }
    })

    this.logSrv.logItem.subscribe(data => {
      if (!data) return;
      if (data) {
        this.onViewSingleActivity(data);
      }
    })
    this.logSrv.refreshNeeded$.subscribe(() => {
      this.feeds.getPageContext();
    })

    this.noteSrv.refreshNeeded$.subscribe(() => {
      this.feeds.getPageContext();
    })
  }

  closeEmailView() {
    const emailViewModal = document.getElementById('viewEmailModal');
    emailViewModal.style.display = "none";
    this.selectedMail = {};
    this.mailAttachments = [];
    this.emailFeedService.mailAttachments.next([]);
    this.emailService.emailToActOn.next({});
  }

  downloadAttachmentByName(name: string) {
    this.emailService.downloadAttachment(name).subscribe((response: any) => {
      const blob = new Blob([response], { type: 'application/octet-stream' });
      FileSaver.saveAs(blob, name);
    })
  }

  downloadAttachment(attachment: any) {
    const { content_type, data, name } = attachment;

    if (!data) {
      return this.downloadAttachmentByName(name);
    }
    // Convert base64 to binary
    const binaryString = atob(data);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Create blob and download
    const blob = new Blob([bytes], { type: content_type });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = name
    link.click();

    URL.revokeObjectURL(url);
  }

  replyMail(message) {
    this.emailService.emailToActOn.next({ ...message, type: 'reply' });
  }

  /**
   * NOTES
   */

  /**
   * Edit notes by ID
   * @param id
   */
  onEditNote(note) {
    this.editUserNote(note);
  }

  /**
  * View note By ID
  * @param id
  */
  onViewSingleNote(id) {
    this.note = {};
    this.showNoteLoading = true;
    this.viewSingleNote(id);
  }

  /**
   * View note By ID
   * @param id
   */
  private viewSingleNote(id) {
    this.editNoteForm.patchValue({ content: '' });
    this.noteSrv.fetchNoteByID(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((note) => {
        this.showNoteLoading = false;
        this.showLoading = false;
        this.note = note;
        this.editNoteForm.patchValue({ content: this.note.content });
      });
  }

  /**
   * Edit notes by ID
   * @param id
   */
  private editUserNote(note) {
    this.showLoading = true;
    this.editNoteForm.patchValue({
      noteID: note.id,
      assigneeID: note.assigneeID,
      clientID: note.clientID,
      clientName: note.clientName,
      creatorName: note.creatorName,
      dealCode: note.dealCode,
      dealName: note.dealName,
      teamID: note.teamID,
      otherName: note.otherName,
      otherID: note.otherID,
      createdDate: note.createdDate,
    });
    if (this.editNoteForm.valid) {
      this.noteSrv.editNote(this.editNoteForm.getRawValue()).subscribe(() => {
        this.showLoading = false;
        $("#closeNoteModal2").click();
        this.generalSrv.sweetAlertFileUpdateSuccessWithoutNav('Note');
        this.feeds.getPageContext();
      }, (error) => {
        this.showLoading = false;
        $("#closeNoteModal2").click();
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      })
    }
  }

  /**
  * LOGES
  */

  /**
 * View Activity Log
 * @param id
 */
  onViewSingleActivity(id, openModal: boolean = false) {
    this.editedOrgAct = {};
    this.showLoading = true;
    this.selectedActivityID = id;
    this.resetCommentState();
    this.resetFollowUpState();
    this.viewSingleActivity(id, openModal);
  }

  /**
   * Clears the comment thread and the draft comment
   */
  private resetCommentState() {
    this.comments = [];
    this.showCommentsLoading = false;
    this.isPostingComment = false;
    this.resetMentionState();
    this.commentForm.reset({ content: '' });
  }

  /**
   * Clears the tagged users and the open picker without touching the draft
   */
  private resetMentionState() {
    this.mentionedUsers = [];
    this.closeMentionPicker();
  }

  /**
   * Clears the follow-up task form
   */
  private resetFollowUpState() {
    this.showFollowUpForm = false;
    this.isCreatingTask = false;
    this.followUpForm.reset({
      name: '',
      description: '',
      assigneeID: this.followUpAssigneeID(),
      dueDate: this.defaultFollowUpDueDate(),
      dueTime: DEFAULT_FOLLOW_UP_TIME
    });
    this.followUpForm.markAsUntouched();
  }

  /**
   * Consumes a one-shot activity open request (sent from a notification)
   */
  private openPendingActivity() {
    if (!this.pageContext) return;
    const id = this.logSrv.consumePendingActivityID();
    if (id === null || id === undefined) return;
    this.onViewSingleActivity(id, true);
  }

  /**
   * Comments can only be read/posted when the org has the ACTIVITIES resource
   */
  canAccessComments(): boolean {
    return this.generalSrv.canAccessResource(this.generalSrv.permissions.resources.activities);
  }

  /**
   * MENTIONS
   */

  /**
   * Reads the caret position of the comment textarea and refreshes the @ suggestions
   */
  onCommentInput() {
    const textarea = this.commentTextarea ? this.commentTextarea.nativeElement : null;
    const value = `${this.commentForm.value.content || ''}`;
    const caret = textarea && typeof textarea.selectionStart === 'number' ? textarea.selectionStart : value.length;
    this.updateMentionSuggestions(value, caret);
  }

  /**
   * Detects a trailing "@query" token before the caret and opens the picker for it
   * @param value the current textarea value
   * @param caret the caret position inside the value
   */
  updateMentionSuggestions(value: string, caret: number) {
    const text = `${value || ''}`;
    const position = typeof caret === 'number' ? caret : text.length;
    const before = text.slice(0, position);
    const match = MENTION_TOKEN_REGEX.exec(before);
    if (!match) {
      this.closeMentionPicker();
      return;
    }
    this.loadOrganisationUsers();
    if (this.isCompletedMention(match[2])) {
      this.closeMentionPicker();
      return;
    }
    this.mentionQuery = match[2];
    this.mentionStart = before.length - match[2].length - 1;
    this.mentionEnd = position;
    this.mentionSuggestions = this.filterMentionUsers(this.mentionQuery);
    this.mentionActiveIndex = 0;
    this.showMentionPicker = this.mentionSuggestions.length > 0;
  }

  /**
   * Keyboard navigation of the open picker; plain typing is left untouched
   */
  onCommentKeydown(event: KeyboardEvent) {
    if (!this.showMentionPicker || !this.mentionSuggestions.length) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.mentionActiveIndex = (this.mentionActiveIndex + 1) % this.mentionSuggestions.length;
      return;
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      const total = this.mentionSuggestions.length;
      this.mentionActiveIndex = (this.mentionActiveIndex - 1 + total) % total;
      return;
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      this.selectMention(this.mentionSuggestions[this.mentionActiveIndex]);
      return;
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeMentionPicker();
    }
  }

  /**
   * Hides the picker shortly after blur so a mousedown selection still wins
   */
  onCommentBlur() {
    setTimeout(() => this.closeMentionPicker(), MENTION_PICKER_BLUR_DELAY);
  }

  /**
   * Replaces the "@query" token with "@Full Name " and records the tagged user
   */
  selectMention(user: MentionUser, event?: Event) {
    if (event) {
      event.preventDefault();
    }
    if (!user) return;
    const value = `${this.commentForm.value.content || ''}`;
    const start = this.resolveMentionStart(value);
    const end = this.resolveMentionEnd(value, start);
    const inserted = `@${user.name} `;
    const content = value.slice(0, start) + inserted + value.slice(end);
    this.commentForm.patchValue({ content });
    if (user.id && !this.mentionedUsers.some((mentioned) => mentioned.id === user.id)) {
      this.mentionedUsers = [...this.mentionedUsers, { id: user.id, name: user.name }];
    }
    this.closeMentionPicker();
    this.focusCommentTextarea(start + inserted.length);
  }

  /**
   * Closes the picker and clears its transient state
   */
  closeMentionPicker() {
    this.showMentionPicker = false;
    this.mentionSuggestions = [];
    this.mentionActiveIndex = 0;
    this.mentionQuery = null;
    this.mentionStart = -1;
    this.mentionEnd = -1;
  }

  /**
   * Normalises the display names of a saved comment: an array, a JSON array
   * string or a plain CSV string are all supported.
   */
  getMentionNames(comment: any): string[] {
    const raw = comment ? comment.mentionedUserNames : null;
    if (raw === null || raw === undefined) return [];
    if (Array.isArray(raw)) return raw.map((name) => `${name}`.trim()).filter((name) => !!name);
    const text = `${raw}`.trim();
    if (!text) return [];
    if (text.charAt(0) === '[') {
      try {
        const parsed = JSON.parse(text);
        if (Array.isArray(parsed)) {
          return parsed.map((name) => `${name}`.trim()).filter((name) => !!name);
        }
      } catch (error) {
        // Not valid JSON: fall back to CSV parsing below
      }
    }
    return text
      .replace(/^\[|\]$/g, '')
      .split(',')
      .map((name) => name.trim().replace(/^["']|["']$/g, '').trim())
      .filter((name) => !!name);
  }

  /**
   * Loads and caches the organisation users the first time the picker is needed
   */
  private loadOrganisationUsers() {
    if (this.organisationUsersRequested) return;
    this.organisationUsersRequested = true;
    this.generalTaskSrv.getAllOrganisationUsers()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((response: any) => {
        this.organisationUsers = this.mapOrganisationUsers(response);
      }, () => {
        // A failed user lookup must never break the comment box
        this.organisationUsers = [];
      });
  }

  /**
   * Maps the user list to { id, name, email }, dropping the current user,
   * inactive users and duplicates.
   */
  private mapOrganisationUsers(response: any): MentionUser[] {
    const rows = this.extractUserRows(response);
    const currentUserID = this.user ? `${this.user.id}` : '';
    const users: MentionUser[] = [];
    rows.forEach((row) => {
      const raw = row && row.user ? row.user : row;
      if (!raw) return;
      if (raw.isActive === false) return;
      const id = raw.id === null || raw.id === undefined ? '' : `${raw.id}`;
      if (!id || id === currentUserID) return;
      if (users.some((existing) => existing.id === id)) return;
      const email = `${raw.email || ''}`.trim();
      const name = `${raw.firstName || ''} ${raw.lastName || ''}`.trim() || email || `User ${id}`;
      users.push({ id, name, email });
    });
    return users;
  }

  /**
   * The organisation user endpoint may answer with the rows directly or wrapped
   * in a data/users envelope.
   */
  private extractUserRows(response: any): any[] {
    if (Array.isArray(response)) return response;
    if (!response || typeof response !== 'object') return [];
    const keys = ['data', 'users', 'userList', 'persons'];
    for (const key of keys) {
      if (Array.isArray(response[key])) return response[key];
    }
    return [];
  }

  /**
   * A completed tag (already inserted "@Full Name ") must not reopen the picker
   */
  private isCompletedMention(query: string): boolean {
    const text = `${query || ''}`;
    if (text.charAt(text.length - 1) !== ' ') return false;
    const typed = text.trim().toLowerCase();
    if (!typed) return false;
    return this.organisationUsers.some((user) => user.name.toLowerCase() === typed);
  }

  /**
   * Filters the cached users by name/email, case insensitive, capped
   */
  private filterMentionUsers(query: string): MentionUser[] {
    const term = `${query || ''}`.toLowerCase().trim();
    return this.organisationUsers
      .filter((user) => {
        if (!term) return true;
        return user.name.toLowerCase().indexOf(term) > -1 || user.email.toLowerCase().indexOf(term) > -1;
      })
      .slice(0, MAX_MENTION_SUGGESTIONS);
  }

  /**
   * Position of the "@" that opened the picker, tolerating a stale index
   */
  private resolveMentionStart(value: string): number {
    if (this.mentionStart >= 0 && value.charAt(this.mentionStart) === '@') return this.mentionStart;
    const fallback = value.lastIndexOf('@');
    return fallback > -1 ? fallback : value.length;
  }

  /**
   * End of the token being replaced; falls back to the end of the value
   */
  private resolveMentionEnd(value: string, start: number): number {
    if (this.mentionEnd >= start && this.mentionEnd <= value.length) return this.mentionEnd;
    return value.length;
  }

  /**
   * Returns focus to the textarea and moves the caret after the inserted name
   */
  private focusCommentTextarea(caret: number) {
    const textarea = this.commentTextarea ? this.commentTextarea.nativeElement : null;
    if (!textarea) return;
    setTimeout(() => {
      textarea.focus();
      if (typeof textarea.setSelectionRange === 'function') {
        textarea.setSelectionRange(caret, caret);
      }
    }, 0);
  }

  /**
   * Tags whose "@Name" is still present in the content are the ones sent
   */
  private getActiveMentions(content: string): MentionedUser[] {
    return this.mentionedUsers.filter((user) => content.indexOf(`@${user.name}`) > -1);
  }

  /**
   * Follow-up tasks can only be created when the org has the TASKS module
   */
  canAccessTasks(): boolean {
    return this.generalSrv.canAccessModule(this.generalSrv.permissions.modules.tasks);
  }

  /**
   * Posts the trimmed draft comment. Only one post can be in flight at a time.
   */
  onPostComment() {
    if (this.isPostingComment || !this.canAccessComments()) return;
    const content = (this.commentForm.value.content || '').trim();
    if (!content) return;
    this.isPostingComment = true;
    const mentions = this.getActiveMentions(content);
    const payload = {
      activityID: this.selectedActivityID,
      content,
      clientID: this.editedOrgAct.clientID,
      otherID: this.editedOrgAct.otherID,
      otherName: this.editedOrgAct.otherName,
      dealCode: this.editedOrgAct.dealCode,
      mentionedUserIDs: mentions.map((user) => user.id),
      mentionedUserNames: mentions.map((user) => user.name)
    };
    this.activityCommentSrv.addComment(payload)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((comment) => {
        this.isPostingComment = false;
        if (comment) {
          this.comments = [...this.comments, comment];
          this.editedOrgAct.commentCount = (this.editedOrgAct.commentCount || 0) + 1;
        }
        this.resetMentionState();
        this.commentForm.reset({ content: '' });
        this.logSrv.refreshNeeded$.next();
      }, (error) => {
        this.isPostingComment = false;
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      });
  }

  /**
   * Shows/hides the inline follow-up task form
   */
  onToggleFollowUpForm() {
    this.showFollowUpForm = !this.showFollowUpForm;
    if (!this.showFollowUpForm) return;
    this.followUpForm.markAsUntouched();
    this.applyFollowUpDefaults();
    if (!this.supervisorUsersLoaded) {
      this.fetchUsersBySupervisor();
    }
  }

  /**
   * Hides the follow-up task form without creating a task
   */
  onCancelFollowUpForm() {
    this.resetFollowUpState();
  }

  /**
   * Creates a follow-up task for the open activity
   */
  onCreateFollowUpTask() {
    if (this.isCreatingTask) return;
    if (this.followUpForm.invalid) {
      this.markFollowUpFormTouched();
      return;
    }
    const body = this.buildFollowUpTaskBody();
    if (!body) {
      this.followUpForm.get('dueDate').markAsTouched();
      this.generalSrv.sweetAlertError('Please choose a valid due date (DD-MM-YYYY)');
      return;
    }
    this.isCreatingTask = true;
    this.logSrv.createFollowUpTask(this.selectedActivityID, body)
      .pipe(takeUntil(this.unsubscribe), finalize(() => this.isCreatingTask = false))
      .subscribe((res: any) => {
        this.showFollowUpForm = false;
        const data = res && res.data ? res.data : res;
        if (data && data.taskID) {
          this.editedOrgAct.linkedTaskID = data.taskID;
          this.editedOrgAct.linkedTaskStatus = data.status;
        }
        this.generalSrv.sweetAlertSucess('Your Follow-up Task Has Been Created');
      }, (error) => {
        this.showFollowUpForm = false;
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      });
  }

  /**
   * Builds the task payload exactly like GeneralTaskService.createTask does,
   * inheriting the client/deal context of the open activity. Returns null when
   * the due date cannot be resolved to a real date.
   */
  private buildFollowUpTaskBody() {
    const form = this.followUpForm.getRawValue();
    const tmpDate = this.resolveFollowUpDueDate(form.dueDate);
    if (!tmpDate) return null;
    const dayValue = tmpDate.getDate();
    const monthValue = tmpDate.getMonth() + 1;
    const day = dayValue < 10 ? `0${dayValue}` : `${dayValue}`;
    const month = monthValue < 10 ? `0${monthValue}` : `${monthValue}`;
    const year = tmpDate.getFullYear();
    const date = `${month}-${day}-${year}`;
    const dateTime = `${date} ${form.dueTime}`;
    const dueDateTime: any = Date.parse(dateTime);
    const activity = this.editedOrgAct || {};
    return {
      assigneeID: `${form.assigneeID}`,
      channel: 'notch',
      clientID: `${activity.clientID || ''}`,
      clientName: `${activity.clientName || ''}`,
      creatorID: `${this.user.id}`,
      dealCode: `${activity.dealCode || ''}`,
      dealName: `${activity.dealName || ''}`,
      description: `${form.description}`,
      dueDate: `${dueDateTime}`,
      dueTime: dueDateTime,
      dueDateTime: `${dueDateTime}`,
      name: `${form.name}`,
      orgID: `${this.orgID}`,
      otherID: `${activity.otherID || ''}`,
      otherName: `${activity.otherName || ''}`,
      status: 'PENDING'
    };
  }

  /**
   * Normalises the datepicker value to a Date: it may come back as a real Date
   * or as a typed DD-MM-YYYY / DD/MM/YYYY string.
   */
  private resolveFollowUpDueDate(value: any): Date | null {
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }
    const text = `${value === null || value === undefined ? '' : value}`.trim();
    if (!text) return null;
    const parts = /^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/.exec(text);
    if (!parts) {
      const parsed = new Date(text);
      return isNaN(parsed.getTime()) ? null : parsed;
    }
    const day = Number(parts[1]);
    const month = Number(parts[2]);
    const year = Number(parts[3]);
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    return date;
  }

  /**
   * Applies the editable due date/time defaults used when the form is opened
   */
  private applyFollowUpDefaults() {
    const value = this.followUpForm.value;
    const defaults: any = {};
    let changed = false;
    if (!(value.dueDate instanceof Date) || isNaN(value.dueDate.getTime())) {
      defaults.dueDate = this.defaultFollowUpDueDate();
      changed = true;
    }
    if (!value.dueTime) {
      defaults.dueTime = DEFAULT_FOLLOW_UP_TIME;
      changed = true;
    }
    if (!value.assigneeID) {
      defaults.assigneeID = this.followUpAssigneeID();
      changed = true;
    }
    if (changed) {
      this.followUpForm.patchValue(defaults);
    }
  }

  /**
   * Tomorrow, at midnight: the default due date of a follow-up task
   */
  private defaultFollowUpDueDate(): Date {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    return tomorrow;
  }

  /**
   * Assignee defaulted to the current user whenever it is known
   */
  private followUpAssigneeID(): string {
    return this.user ? `${this.user.id}` : '';
  }

  /**
   * Angular 7 has no markAllAsTouched: touch every follow-up control so the
   * inline errors become visible
   */
  private markFollowUpFormTouched() {
    Object.keys(this.followUpForm.controls).forEach((key) => {
      const control = this.followUpForm.get(key);
      if (control) control.markAsTouched();
    });
  }

  /**
   * Makes sure the current user is always selectable, even when the subordinate
   * lookup fails, and keeps the assignee field populated.
   */
  private seedCurrentUserForFollowUp() {
    if (!this.user) return;
    const id = `${this.user.id}`;
    const fullName = `${this.user.firstName || ''} ${this.user.lastName || ''}`.trim();
    const currentUser = {
      id,
      salesPerson: `${this.user.salesPerson || ''}`,
      fullName: fullName || `${this.user.email || ''}` || `User ${id}`
    };
    const others = (this.supervisorAttachedUsers || []).filter((person) => `${person.id}` !== id);
    this.supervisorAttachedUsers = [currentUser, ...others];
    if (!this.followUpForm.value.assigneeID) {
      this.followUpForm.patchValue({ assigneeID: id });
    }
  }

  /**
   * Merges the fetched subordinates with the already seeded users, deduped by id
   */
  private mergeFollowUpUsers(fetched: any[]): any[] {
    const merged: any[] = [];
    [...(this.supervisorAttachedUsers || []), ...(fetched || [])].forEach((person) => {
      if (!person) return;
      const id = `${person.id}`;
      if (merged.some((existing) => existing.id === id)) return;
      merged.push(person);
    });
    return merged;
  }

  /**
   * Fetch the users the current user can assign a task to, plus the user
   */
  private fetchUsersBySupervisor() {
    if (!this.user || this.supervisorUsersLoading) return;
    this.supervisorUsersLoading = true;
    const getSurbodinates = this.signupSrv.fetchTaskSubordinates(this.user.email).pipe(map(subs => {
      const res = (subs || []).filter((person) => person.salesPerson === 'true');
      const result = res.concat(this.user);
      return result.map(sub => ({
        id: `${sub.id}`,
        salesPerson: `${sub.salesPerson}`,
        fullName: `${sub.firstName} ${sub.lastName}`
      }));
    }));
    forkJoin([getSurbodinates])
      .pipe(takeUntil(this.unsubscribe), finalize(() => this.supervisorUsersLoading = false))
      .subscribe((responses) => {
        this.supervisorAttachedUsers = this.mergeFollowUpUsers(responses[0]);
        this.supervisorUsersLoaded = true;
      }, () => {
        // A failed lookup keeps the current user as the only, still valid, option
        this.seedCurrentUserForFollowUp();
      });
  }

  /**
  * Edit Activity Log
  */
  onEditActivity(editedOrgAct) {
    this.editActivityForm.patchValue({
      id: this.selectedActivityID,
      assigneeID: editedOrgAct.assigneeID,
      clientID: editedOrgAct.clientID,
      clientName: editedOrgAct.clientName,
      createdDate: editedOrgAct.createdDate,
      creatorName: editedOrgAct.creatorName,
      dateLogged: editedOrgAct.dateLogged,
      dealCode: editedOrgAct.dealCode,
      dealName: editedOrgAct.dealName,
      duration: editedOrgAct.duration,
      otherName: editedOrgAct.otherName,
      otherID: editedOrgAct.otherID,
      teamID: editedOrgAct.teamID,
    });
    this.editActivity();
  }

  get f() { return this.editActivityForm.controls; }

  /**
   * View Activity Log
   * @param id
   */
  private viewSingleActivity(id, openModal: boolean = false) {
    this.logSrv.getSingleActivityLog(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((editedOrgAct) => {
        this.showLoading = false;
        this.editedOrgAct = editedOrgAct || {};
        this.f.content.setValue(this.editedOrgAct.content);
        this.f.type.setValue(this.editedOrgAct.type);
        this.f.id.setValue(this.editedOrgAct.id);
        if (openModal) {
          $('#viewActivityModal').modal('show');
        }
      }, () => {
        this.showLoading = false;
      });

    if (!this.canAccessComments()) {
      this.comments = [];
      this.showCommentsLoading = false;
      return;
    }
    this.showCommentsLoading = true;
    this.activityCommentSrv.getComments(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((comments) => {
        this.showCommentsLoading = false;
        this.comments = comments || [];
      });
  }

  /**
   * Edit Activity Log
   */
  private editActivity() {
    this.showEditLoading = true;
    this.logSrv.updateActivityLog(this.editActivityForm.getRawValue())
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: any) => {
        this.showEditLoading = false;
        $("#closeLogModal").click();
        this.generalSrv.sweetAlertFileUpdateSuccessWithoutNav('Activity');
        this.feeds.getPageContext();
      }, (error) => {
        this.showEditLoading = false;
        $("#closeLogModal").click();
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      })
  }

  /**
   * Fetch Activity Type
   */
  private fetchLogActivityTypes() {
    this.logSrv.getActivityTypes().pipe(takeUntil(this.unsubscribe)).subscribe(activityType => {
      this.activityType = activityType;
    })
  }


  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
